import { cn } from "@/lib/utils";

export default function SectionHeading({
  eyebrow,
  title,
  description,
  align = "left",
  light = false,
  className = "",
  testid,
}) {
  return (
    <div
      data-testid={testid}
      className={cn(
        "max-w-3xl",
        align === "center" && "mx-auto text-center",
        className,
      )}
    >
      {eyebrow && (
        <p className={cn("mb-4", light ? "eyebrow-light" : "eyebrow")}>
          {eyebrow}
        </p>
      )}
      <h2
        className={cn(
          "text-3xl sm:text-4xl md:text-[44px] font-light tracking-tight leading-[1.05]",
          light ? "text-brand-off" : "text-brand-charcoal",
        )}
      >
        {title}
      </h2>
      {description && (
        <p
          className={cn(
            "mt-5 text-[16.5px] leading-relaxed max-w-2xl",
            align === "center" && "mx-auto",
            light ? "text-white/70" : "text-brand-muted",
          )}
        >
          {description}
        </p>
      )}
    </div>
  );
}
